@if (isOpen$ | async) {
  <div
    class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in"
    (click)="onCancel()"
  >
    <div
      class="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div class="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50">
        <h3 class="text-xl font-bold text-gray-800 flex items-center gap-2">
          <lucide-icon [img]="icons.AlertTriangle" class="w-5 h-5 text-red-500"></lucide-icon>
          {{ title$ | async }}
        </h3>
        <button (click)="onCancel()" class="text-gray-400 hover:text-gray-600 cursor-pointer">
          <lucide-icon [img]="icons.X" class="w-5 h-5"></lucide-icon>
        </button>
      </div>

      <!-- Content -->
      <div class="p-6">
        <p class="text-gray-600">{{ message$ | async }}</p>
      </div>

      <!-- Footer -->
      <div class="p-6 pt-0 flex gap-3 justify-end">
        <button
          (click)="onCancel()"
          class="px-4 py-2 text-gray-600 font-medium bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors cursor-pointer"
        >
          {{ cancelText$ | async }}
        </button>
        <button
          (click)="onConfirm()"
          class="px-4 py-2 text-white font-bold rounded-lg transition-colors cursor-pointer"
          [style.backgroundColor]="confirmColor$ | async"
        >
          {{ confirmText$ | async }}
        </button>
      </div>
    </div>
  </div>
}
